import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// ----> USER CONTEXT IMPORTATION
// import { UserContext } from "../../context/UserContext";


// components importation
import { NavBarComp } from "../../components/navbar-comp/NavBarComp.jsx";





export const ProtectedRoutes = () => {

  // const { user } = useContext(UserContext);

  const isLogged = localStorage.getItem("token");

  // if (!isLogged) {
  //   return <Navigate to="/" />
  // }

  return (
    <>
      <NavBarComp />
      <div className="grid-wrapper">
        <Outlet />
      </div>
    </>
  );
};